import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

/**
 * Component that handles 301-style redirects for legacy blog URLs
 * that don't have the /blog/ prefix
 */
export function BlogRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Extract the slug from the current path (remove leading slash)
    const slug = location.pathname.slice(1);
    // Redirect to the proper /blog/ URL with replace to simulate 301
    navigate(`/blog/${slug}`, { replace: true });
  }, [navigate, location.pathname]);

  return null;
}
